// extracted by mini-css-extract-plugin
var _1 = "PostEditButton-module__backlinksPreview--X8rXR";
var _2 = "PostEditButton-module__container--SNu3H";
var _3 = "PostEditButton-module__icon--vaWg5";
var _4 = "PostEditButton-module__overflowMenu--EhuB2";
var _5 = "PostEditButton-module__shareButton--Ay0iQ";
var _6 = "PostEditButton-module__tooltip--Ogrxv";
export { _1 as "backlinksPreview", _2 as "container", _3 as "icon", _4 as "overflowMenu", _5 as "shareButton", _6 as "tooltip" }
